

























import {defineComponent} from "@vue/composition-api";
import CloseButtonAtom from "@/shared/components/atoms/CloseButtonAtom.vue";
import {useState} from "vuex-composition-helpers";

export default defineComponent({
  name: "Popup",
  components: {
    CloseButtonAtom,
  },
  props: {
    showBackButton: {type: String, required: true},
    labels: {type: Object, required: true}
  },
  setup: () => {
    const {selectedCategory} = useState(['selectedCategory'])
    return {
      selectedCategory
    }
  }
})
